/**
 * Relatos crypto core — board metadata encryption.
 *
 * Board definition events (kind 34553) carry name/description encrypted under the
 * current epoch key. Non-members (and relays) see only scrambled ciphertext — the
 * UI must render that as "encrypted board", never as an error or a conspicuous
 * empty board (CLAUDE.md, architecture invariants).
 */
import { boardEncrypt, boardDecrypt, boardCanDecrypt } from './nip44';

export interface BoardMeta {
  name: string;
  description: string;
  /** unix seconds */
  createdAt: number;
  /** Admin's per-board pseudonymous posting pubkey (inside the ciphertext).
   *  Lets members recognize admin actions (deletions) without the admin's
   *  identity key ever signing an in-board event. */
  adminPk?: string;
}

export function encryptBoardMeta(epochKeyHex: string, meta: BoardMeta): string {
  return boardEncrypt(epochKeyHex, { t: 'meta', ...meta });
}

export function decryptBoardMeta(epochKeyHex: string, ct: string): BoardMeta {
  const d = boardDecrypt<{ t: string } & BoardMeta>(epochKeyHex, ct);
  if (d.t !== 'meta') throw new Error('not board metadata');
  return { name: d.name, description: d.description, createdAt: d.createdAt, adminPk: d.adminPk };
}

export function canReadBoardMeta(epochKeyHex: string, ct: string): boolean {
  return boardCanDecrypt(epochKeyHex, ct);
}
